module.exports = __webpack_public_path__ + "@/assets/img/teclabCreditsPig.cb192baa.png";